export const Authorize_B2B_User = "Authorize_B2B_User";
export const Deauthorize_B2B_User = "Deauthorize_B2B_User";
export const Refresh_User_Token = "Refresh_User_Token";
export const Logout_Clear_State = "Logout_Clear_State";
export const Auth_Errors_Clear_State = "Auth_Errors_Clear_State";